import React from 'react';

const InputForm = ({ id, name, type, label, handleChange, value, handleOnBlur }) => {
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input
        value={value}
        type={type}
        id={id}
        name={name}
        onBlur={
          (e) => {
            if(handleOnBlur){
              handleOnBlur(e);
            }
          }
        }
        onChange={
          (e) => {
            if(handleChange){
              handleChange(e);
            }
          }
        }
      />
    </div>
  );
};

export default InputForm;
